<template>
  <register-layout
    title="개인정보 수집·활용 및 제 3자 제공 동의서"
    @close="onClickClose"
    @prev="onClickPrev"
    @next="onClickNext"
  >
    <div class="privacy-consent ">
      <section>
        <p>개인정보의 수집 및 이용에 관한 안내 및 동의</p>
        <div class="print-textarea overflow-y-auto" style="min-height: 100px;">
          동국제강㈜은 개인정보보호법에 따라 안전환경통합시스템에 회원가입을 신청하시는 분께 수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간, 동의 거부권 및 동의 거부시 불이익에 관한 사항을 아래와 같이 안내 드리오니 내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오.
        </div>
      </section>

      <section>
        <p>1. 개인정보의 수집 및 이용에 관한 안내 및 동의</p>
        <div class="print-textarea overflow-y-auto items" style="height: 295px;">
          1. 개인정보의 수집·이용 목적<br>
          중대재해처벌법 대응을 위한 디지털 안전보건관리 시스템 운영/제공<br>
          2. 수집하려는 정보의 항목<br>
          성명, 생년월일, 사업장 이름, 사업장 관리번호, 전화번호 및 안전·보건 관련 일반 정보<br>
          3. 개인정보의 보유 및 이용기간<br>
          수집된 개인정보는 중대재해처벌법 대응을 위한 디지털 안전보건관리 시스템을 운영하기 위하여 일정 기간 동안만 보유하며 그 이후는 관련 법령에 따라 폐기하고 있습니다.<br>
          - 보존기간: 수집일로부터 3년<br>
          4. 동의거부 권리 및 거부에 따른 불이익<br>
          본 동의는 개인정보 수집·이용에 대한 동의로써, 동의하지 않으실 경우 안전환경 통합시스템 이용에 제한 받을 수 있습니다.<br>
          ※ 법령에 따른 개인정보의 수집·이용, 계약의 이행·편의 증진을 위한 개인정보 처리위탁 및 개인정보 처리와 관련된 일반 사항은 개인정보 처리방침에 따릅니다.<br>
        </div>
        <vs-checkbox v-model="agreement1">위 개인정보 수집·이용에 동의합니다</vs-checkbox>
      </section>

      <section class="border-top pt-4">
        <vs-checkbox :value="agreement1" @change="agreementAll">전체동의</vs-checkbox>
      </section>
    </div>
  </register-layout>
</template>

<script>
import RegisterLayout from "@/views/pages/register/RegisterLayout.vue";

export default {
  name: "PrivacyConsent",
  components: {RegisterLayout},
  data() {
    return {
      agreement1: false
    }
  },
  methods: {
    agreementAll() {
      this.agreement1 = !this.agreement1;
    },
    onClickClose() {
      this.$emit('close');
    },
    onClickPrev() {
      this.$emit('prev');
    },
    onClickNext() {
      if (!this.agreement1) {
        alert("개인정보 수집·이용 및 제 3자 제공에 동의해 주세요.")
        return;
      }
      this.$emit('next');
    }
  }
}
</script>

<style scoped lang="scss">
section { display: grid; gap: 0.625rem; margin-bottom: 20px;}
section:last-child { margin-bottom: 48px; }
.print-textarea { margin: 0; }
.privacy-consent {
  font-size: 1rem;
}
section > p {
  font-weight: 500;
}

.privacy-consent-header {
  padding: 12px 30px;

  background-color: #f5f5f5;
  color: #222222;
  font-size: 18px;
  font-width: bold;

  border-bottom: 1px solid #cdcdcd;
}
.items { margin-bottom: 10px; }
.items > div {  margin-bottom: 10px; }
.items > div > p:first-child {  font-weight: bold; }
.border-top { border-top: 1px solid #cdcdcd; }
</style>
